import { TableHeaderItem } from "@/views/components/YtoTable/TableHeaderItem";

const defaultWidth = 300;

const tableHeader: TableHeaderItem[] = [
  { prop: 'index', label: '序号', width: 60, fixed: "left" },
  { prop: 'code', label: '实物条码', width: defaultWidth, fixed: "left" },
  { prop: 'CarSignNum', label: '车签号', width: 200 , fixed: "left"},
  { prop: 'RecvType', label: '收发类型', width: 130 },
  { prop: 'NextWebPoint', label: '下一网点', width: 160 },
  { prop: 'Line', label: '线路', width: defaultWidth },
  { prop: 'ScanTime', label: '扫描时间', width: 200 },
  { prop: 'UploadStateName', label: '状态', width: 90 ,fixed: "right"},
  { prop: 'Info', label: '提示/警告信息', width: null , fixed: "right"},
];
export default { tableHeader }
